module.exports = __webpack_public_path__ + "static/media/saso_kramberger_cut.426d6cbf.jpg";